import { render } from "./ServiceRequired.vue?vue&type=template&id=a65e3572&ts=true"
import script from "./ServiceRequired.ts?vue&type=script&lang=ts&external"
export * from "./ServiceRequired.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__